<template>
  <v-flex>
    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense :color="colorBarraFormulario" flat>
        <v-toolbar-title>Cuestionario</v-toolbar-title>
        <v-divider class="mx-4" inset vertical />
        <v-spacer />
        <v-btn small depressed :color="colorAccent1" class="white--text" :loading="loading" @click="cargarPreguntas">
          <v-icon left>mdi-refresh</v-icon>Actualizar
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="mt-0" align="center" dense>
          <v-col cols="12" sm="8">
            <div class="subtitle-1 font-weight-medium">Catálogo de preguntas</div>
            <p class="mb-0">Preguntas por categoría de proveedor y preguntas generales de Rutas Meigas. Valoración del 1 al 10; respuestas y comentarios opcionales.</p>
          </v-col>
          <v-col cols="12" sm="4">
            <v-select v-model="idioma" :dark="dark" :items="idiomas" label="Idioma de las preguntas" outlined dense hide-details />
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
    <v-card class="ma-2" color="rgb(250, 250, 250)">
      <v-card-text>
        <v-progress-linear v-if="loading" class="my-4" indeterminate :color="colorAccent1" rounded height="6" aria-label="Cargando preguntas" />
        <v-alert v-else-if="error" class="mt-4" type="error" outlined role="alert">
          {{ error }}
          <v-btn text small @click="cargarPreguntas">Reintentar</v-btn>
        </v-alert>
        <template v-else>
          <v-alert v-if="!grupos.length" class="mt-4" type="info" outlined>No hay categorías ni preguntas disponibles.</v-alert>
          <v-card v-for="grupo in grupos" :key="grupo.categoria_proveedor_id === null ? 'empresa' : grupo.categoria_proveedor_id" class="mb-2" color="rgb(250, 250, 250)">
            <v-toolbar :dark="!dark" dense color="rgb(120, 130, 120)" flat>
              <v-chip label small color="rgb(60, 60, 60)" text-color="white">{{ grupo.preguntas.length }} preguntas</v-chip>
              <v-divider class="mx-2" inset vertical />
              <v-toolbar-title>{{ grupo.categoria_proveedor_nombre }}</v-toolbar-title>
              <v-spacer />
              <!-- Controles visuales pendientes de conectar con el CRUD. -->
              <v-chip label class="mr-2" link :color="colorAccent1">
                <span style="color: white;">Nueva pregunta</span>
              </v-chip>
            </v-toolbar>
            <v-card-text>
            <v-data-table
              locale="es" dense class="elevation-1 alternating-rows bordered-table"
              :headers="headers" :items="grupo.preguntas" item-key="id"
              :items-per-page="-1" hide-default-footer :sort-by="['orden', 'id']" :must-sort="true"
              no-data-text="No hay preguntas configuradas para esta categoría."
            >
              <template v-slot:[`item.titulo`]="{ item }">{{ texto(item, 'titulo') }}</template>
              <template v-slot:[`item.pregunta`]="{ item }">{{ texto(item, 'pregunta') }}</template>
              <template v-slot:[`item.comentario`]="{ item }">
                {{ item.permite_comentario ? texto(item, 'pregunta_comentario') : 'No permite comentarios' }}
              </template>
              <template v-slot:[`item.activa`]="{ item }">
                <v-chip label small :color="item.activa ? 'green lighten-1' : 'red lighten-2'" text-color="white">{{ item.activa ? 'ACTIVA' : 'INACTIVA' }}</v-chip>
              </template>
              <template v-slot:[`item.acciones`]="{ item }">
                <div class="d-flex justify-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip label class="mr-1 px-1" link :color="colorAccent3" :aria-label="'Editar pregunta: ' + texto(item, 'titulo')" v-bind="attrs" v-on="on">
                        <v-icon color="white">mdi-pencil</v-icon>
                      </v-chip>
                    </template>
                    <span>Editar pregunta</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip label class="mr-1 px-1" link color="red lighten-2" :aria-label="'Eliminar pregunta: ' + texto(item, 'titulo')" v-bind="attrs" v-on="on">
                        <v-icon color="white">mdi-delete</v-icon>
                      </v-chip>
                    </template>
                    <span>Eliminar pregunta</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
            </v-card-text>
          </v-card>
        </template>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState } from 'vuex';
import { listarPreguntasValoracion } from '@/services/valoraciones';

export default {
  name: 'Valoraciones',
  data: () => ({
    grupos: [],
    loading: false,
    error: '',
    idioma: 'ES',
    idiomas: [
      { text: 'Español', value: 'ES' },
      { text: 'English', value: 'EN' },
      { text: 'Deutsch', value: 'DE' },
    ],
    headers: [
      { text: 'Orden', value: 'orden', width: 90 },
      { text: 'Título', value: 'titulo', sortable: false },
      { text: 'Pregunta', value: 'pregunta', sortable: false },
      { text: 'Texto del comentario (opcional)', value: 'comentario', sortable: false },
      { text: 'Estado', value: 'activa', width: 110 },
      { text: 'Acciones', value: 'acciones', sortable: false, align: 'center', width: 100 },
    ],
  }),
  computed: {
    ...mapState(['dark', 'colorBarraFormulario', 'colorAccent1', 'colorAccent3']),
    ...mapState('auth', ['access_token']),
  },
  created() {
    this.cargarPreguntas();
  },
  methods: {
    texto(pregunta, campo) {
      return pregunta[campo + '_' + this.idioma] || 'Sin traducción';
    },
    async cargarPreguntas() {
      if (this.loading) return;
      this.loading = true;
      this.error = '';
      try {
        this.grupos = await listarPreguntasValoracion(this.access_token);
      } catch (error) {
        this.grupos = [];
        this.error = 'No se pudo cargar el catálogo de preguntas. Inténtalo de nuevo.';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.alternating-rows ::v-deep tbody tr:nth-child(even) {
  background-color: #ebebeb !important;
}

.bordered-table {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

.bordered-table ::v-deep th,
.bordered-table ::v-deep td {
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep th:last-child,
.bordered-table ::v-deep td:last-child {
  border-right: none !important;
}

.bordered-table ::v-deep tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep thead tr:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.bordered-table ::v-deep td {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  overflow-wrap: anywhere;
}
</style>
